import React, { PropsWithChildren } from "react";

import { tw } from "~/utils";

interface CardProps extends PropsWithChildren {
  className?: string;
  title?: string;
}

export const Card = ({ children, className, title }: CardProps) => (
  <div
    className={tw(
      "border-blueGrey flex flex-col items-center space-y-10 rounded-lg border bg-white p-6",
      className,
    )}
  >
    {title && (
      <h2 className="text-indigo text-center font-sans text-lg font-medium">
        {title}
      </h2>
    )}
    {children}
  </div>
);
